// Per-key fallback when the build didn't inject the var (e.g. Cloudflare Pages project
// missing the env setting). rec_server is a separate service from the main API, so it
// cannot fall back to same-origin like VITE_API_BASE_URL does — that would silently point
// at the static admin site itself with nothing behind that path.
const FALLBACK_URLS: Partial<Record<"VITE_API_BASE_URL" | "VITE_REC_API_BASE_URL" | "VITE_WEB_FRONTEND_URL", string>> = {
  VITE_REC_API_BASE_URL: "https://rec.gullivr.ai",
};

const getEnv = (key: "VITE_API_BASE_URL" | "VITE_REC_API_BASE_URL" | "VITE_WEB_FRONTEND_URL"): string => {
  const value = import.meta.env[key];
  if (!value) {
    const fallback = FALLBACK_URLS[key];
    if (fallback) return fallback;
    // Fall back to same origin so the app still works when the build arg was not injected.
    return typeof window !== "undefined" ? window.location.origin : "";
  }
  return value;
};

export const env = {
  apiBaseUrl: getEnv("VITE_API_BASE_URL"),
  recApiBaseUrl: getEnv("VITE_REC_API_BASE_URL"),
  /** Buyer-facing web-frontend origin (gullivr.ai) used to build shareable deal links from the admin panel. */
  webFrontendUrl: getEnv("VITE_WEB_FRONTEND_URL"),
  flyerPreviewEnabled: import.meta.env.VITE_FLYER_PREVIEW_ENABLED !== "false",
  /** Set VITE_BACKGROUND_JOBS_BAR=false to hide the floating jobs bar (e.g. in mobile WebView builds). */
  backgroundJobsBarEnabled: import.meta.env.VITE_BACKGROUND_JOBS_BAR !== "false",
};
